import {UntypedFormControl} from '@angular/forms';
import {parse} from 'libphonenumber-js';
import {PhoneNumbersUtils} from '../utilities/phone-numbers-helpers';

export function phoneNumberValidator(control: UntypedFormControl): {[key: string]: any} {
  if (control.value) {
    const phoneNumber = parse(control.value, {defaultCountry: 'US', extended: true});
    if (!phoneNumber.valid && !PhoneNumbersUtils.isShortCode(control.value)) {
      return { invalidPhoneNumber: true };
    }

    return undefined;
  }
  return undefined;
}
